export function convertQuestionsTypeLabel(value) {

    let result = '';

    switch (value) {
        case 'number':
            result = 'Numérico'
            break;
        case 'text':
            result = 'Texto'
            break;
        case 'bool':
            result = 'Verdadero/Falso'
            break;
        case 'file':
            result = 'Archivo'
            break;
        case 'date':
            result = 'Fecha'
            break;
        case 'textarea':
            result = 'Párrafo'
            break;
        case 'select':
            result = 'Selección'
            break;
        case 'form':
            result = 'Formulario'
            break;
        default:
            result = 'Desconocido'
            break;
    }

    return result;
}

export function convertQuestionsTypeInput(value) {

    let result = '';

    switch (value) {
        case 'number':
            result = 'number'
            break;
        case 'text':
            result = 'text'
            break;
        case 'decision':
            result = 'checkbox'
            break;
        case 'file':
            result = 'file'
            break;
        case 'date':
            result = 'date'
            break;
        case 'textarea':
            result = 'textarea'
            break;
        default:
            result = 'desconocido'
            break;
    }

    return result;
}

export function convertAccuserType(value) {

    let result = '';

    switch (value) {
        case 'register':
            result = 'Registrado'
            break;
        case 'anonymous':
            result = 'Externo'
            break;
        case null:
            result = 'Anónimo'
            break;
        default:
            result = 'Desconocido'
            break;
    }

    return result;
}

/*
    determina el destinatario
    si el destinatario es el encargado o es admin entonces,
    el resultado es null,
    cuando el resultado es null quiere decir que el filtro de destinatario no se aplicara para ese rol,
    Caso de uso: en los casos donde se deba aplicar filtro de destinatario (a quines van dirigidos)
 */
export function applyDestinationFilter(value) {

    let result = '';

    switch (value) {
        case 'Oficial de cumplimiento':
            result = null
            break;
        case 'administrador':
            result = null
            break;
        default:
            result = value
            break;
    }

    return result;
}

/*
    determina el acusador
    permite establecer un filtro, en el caso de que sea admin o encargado de prevencion del delito,
    entonces, debe establacerce nulo el resultado de lo contrario retorna el correo del acusador
    Caso de uso: en los filtro donde se requiera aplicar filtro de acusador
 */
export function applyAccuserFilter(mail, rol) {

    let result = '';

    switch (rol) {
        case 'Oficial de cumplimiento':
            result = null
            break;
        case 'administrador':
            result = null
            break;
        default:
            result = mail
            break;
    }

    return result;
}

export function formatRut(rut) {
    const rutFormat = rut
        .replace(/[^0-9kK]/g, '')
        .padEnd(8, '_')
        .split('')

    const groups = rutFormat.slice(0, rutFormat.length - 1).reduceRight((acc, digit) => {
        const currentGroup = acc[0];
        if (currentGroup.length === 3) {
            acc.unshift([digit]);
        } else {
            currentGroup.unshift(digit);
        }
        return acc

    }, [[]])

    const firstPart = groups.map(x => x.join('')).join('.')

    return `${firstPart}-${rutFormat[rutFormat.length - 1]}`
}


export function formatDateInput(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function formatDateTime(date) {
    if (date == null) {
        return;
    }

    // Crear un objeto Date con la fecha y hora ISO
    var fechaHora = new Date(date);

    // Formatear la fecha y hora en un formato legible para el usuario
    var opcionesFormato = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
    return fechaHora.toLocaleDateString('es-ES', opcionesFormato);
}

export function formatDate(date) {
    if (date == null) {
        return;
    }

    var newDate = new Date(date);

    var opcionesFormato = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return newDate.toLocaleDateString('es-ES', opcionesFormato);
}

export function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function validateNonEmpty(value, validate = true) {
    if (Array.isArray(value)) {
        return !validate || value.length > 0 ? null : false;
    }
    return !validate || (value !== '' && value !== null) ? null : false;
}

export function validateRut(event) {
    const charCode = event.charCode;

    if (charCode <= 32) { // control characters
        return;
    }
    
    if (charCode >= 48 && charCode <= 57) { // numbers
        return;
    }
    
    if (charCode === 75 || charCode === 107) { // allow for k and K
        let text = event.target.value;

        if (text.length >= 7) {
            return;
        }
        event.preventDefault();
    } else {
        event.preventDefault();
    }
}

export function formatBoolean(approved) {
    return approved ? 'Sí' : 'No'
}
export function formatAssistantName(assistant) {
    if (assistant.name === 'no definido' || assistant.lastName === 'no definido') {
        return 'Externo';
    }
    return `${assistant.name} ${assistant.lastName}`;
}

export function formatVisitor(visitor) {
    return `${visitor.mail} (${formatDateTime(visitor.dateSeen)})`;
}
export function formatComment(comment) {
    return `${comment.comment} - ${comment.author} (${formatDateTime(comment.creationDate)})`        
}
export function formatApproval(approval){
    if (approval === null) {
        return 'Pendiente';
    }

    return approval.approved ? 'Aprobado' : 'Rechazado';
}

